module.exports = __webpack_public_path__ + "img/image2019-3-12_17_26_33.abbfd0dd.png";